/**
 * ロケールの送信処理部品
 * @param {ng.IQService} $q
 * @param {ng.auto.IInjectorService} $injector
 */
/* @ngInject */
export function interceptor(
    $q: ng.IQService,
    $injector: ng.auto.IInjectorService
): ng.IHttpInterceptor {
    return {
        request: (config: ng.IRequestConfig): (ng.IRequestConfig|ng.IPromise<ng.IRequestConfig>) => {
            let $translate: ng.translate.ITranslateService = <ng.translate.ITranslateService> $injector.get('$translate');
            if ($translate && $translate.use()) {
                config.headers['X-HAF-DS-locale'] = $translate.use();
            }
            return config || $q.when(config);
        }
    };
};



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/common/interceptor.ts
 **/